// Vanity number search - combines online dictionary (Datamuse for English) with local Romanian words

// T9 keyboard letter to digit mapping
const letterToDigit = {
  'A': '2', 'B': '2', 'C': '2',
  'D': '3', 'E': '3', 'F': '3',
  'G': '4', 'H': '4', 'I': '4',
  'J': '5', 'K': '5', 'L': '5',
  'M': '6', 'N': '6', 'O': '6',
  'P': '7', 'Q': '7', 'R': '7', 'S': '7',
  'T': '8', 'U': '8', 'V': '8',
  'W': '9', 'X': '9', 'Y': '9', 'Z': '9',
  '0': '0', '1': '1', '2': '2', '3': '3', '4': '4',
  '5': '5', '6': '6', '7': '7', '8': '8', '9': '9'
};

// Convert letters to phone digits
export const lettersToDigits = (input) => {
  if (!input) return '';
  return input.toUpperCase().split('').map(c => letterToDigit[c] || '').join('');
};

// Romanian words (local dictionary - no good free API available)
const romanianWords = [
  // 3 letters
  'ANA', 'APE', 'AER', 'AUR', 'AZI', 'BAR', 'BUN', 'CAP', 'CAS', 'CEA', 'CER', 'COD', 'CUM', 'DAR', 'DIN', 'DOI', 'DOR',
  'ERA', 'FAC', 'FEL', 'FOC', 'GAZ', 'GEN', 'HAI', 'IAR', 'JOC', 'JOS', 'LAC', 'LEI', 'LEU', 'LOC', 'LOR', 'LUI', 'MAI',
  'MAR', 'MEU', 'MIC', 'MOD', 'MOR', 'NAI', 'NOU', 'NUC', 'ORA', 'OUA', 'PAR', 'PAS', 'POM', 'PUI', 'RAU', 'ROZ', 'SAC',
  'SAT', 'SEC', 'SOC', 'SOS', 'SUS', 'TAU', 'TIN', 'TOT', 'TUN', 'UNA', 'URS', 'VIN', 'VIS', 'VIU', 'ZAR', 'ZEI', 'ZID',
  // 4 letters
  'ACUM', 'ALTA', 'ANUL', 'AVEM', 'BANI', 'BINE', 'BLOC', 'BRAT', 'BUNA', 'CALD', 'CALE', 'CALM', 'CARE', 'CASA', 'CAUT',
  'CEAI', 'CEAS', 'CHEF', 'CHEI', 'CHIP', 'CINE', 'CITI', 'COLT', 'CORP', 'COST', 'CRED', 'CUPA', 'CURS', 'DACA', 'DATA',
  'DEAL', 'DECI', 'DEJA', 'DISC', 'DOAR', 'DOUA', 'DUPA', 'ESTE', 'EURO', 'FACE', 'FACI', 'FARA', 'FATA', 'FAPT', 'FAZA',
  'FIER', 'FILM', 'FOST', 'FRIG', 'GARD', 'GATA', 'GLAS', 'GOLF', 'GRAD', 'GRAS', 'GREU', 'GRUP', 'GUST', 'IATA', 'IUBI',
  'JUCA', 'LASA', 'LEGE', 'LUNA', 'LUNG', 'MAMA', 'MARE', 'MASA', 'MECI', 'MEGA', 'MELE', 'MENU', 'MERG', 'MICA', 'MINE',
  'MODI', 'MORT', 'MULT', 'MUZA', 'NAVE', 'NICI', 'NORD', 'NOTA', 'NOUL', 'NOVA', 'NUCA', 'OAIA', 'OALA', 'OAZA', 'OCHI',
  'PACE', 'PACT', 'PANA', 'PARA', 'PARK', 'PART', 'PATA', 'PLAN', 'PLAT', 'PLIC', 'PLIN', 'PLOI', 'PLUG', 'PLUS', 'PORC',
  'PORT', 'POST', 'PREA', 'PRET', 'PRIM', 'PRIN', 'RADE', 'RARA', 'RASA', 'RATA', 'RAZA', 'REAL', 'RECE', 'REGE', 'RUPT',
  'SALA', 'SAPA', 'SARE', 'SARI', 'SATU', 'STAT', 'STII', 'STOP', 'SUNA', 'SUPA', 'SURD', 'TAXI', 'TIMP', 'TINE', 'TOTI',
  'TRAI', 'TREI', 'UITE', 'UNDE', 'URMA', 'VAND', 'VEDE', 'VENI', 'VEST', 'VIDA', 'VINA', 'VINE', 'VREA', 'ZONA', 'ZORI',
  // 5 letters
  'ACASA', 'ADEVAR', 'ATENT', 'AJUTA', 'ALEGE', 'ALTUL', 'ANUME', 'FOARTE', 'APARA', 'ARATA', 'ASTEA', 'AUTOR', 'BANCA',
  'BIROU', 'BUCUR', 'CARTE', 'CAUZA', 'CHIAR', 'CIFRA', 'CINCI', 'CITAT', 'CLASA', 'COUNT', 'CREAT', 'DREPT', 'ECHIP',
  'EMAIL', 'EXACT', 'FACIL', 'FINIT', 'FORMA', 'GANZI', 'HOTEL', 'IDELE', 'IMENS', 'INALT', 'INIMA', 'JOACA', 'LIMBA',
  'LOCUL', 'LUMEA', 'MAINE', 'MASAJ', 'MERIT', 'MOBIL', 'MODEL', 'MOTOR', 'MUNCA', 'MUSCA', 'NASTE', 'NUMAI', 'OMEGA',
  'OPERA', 'OPTIM', 'PATRU', 'PIZZA', 'PLATA', 'PLIMB', 'POATE', 'PRANZ', 'PRIMA', 'PUNCT', 'RADIO', 'RAPID', 'ROMAN',
  'RUGAM', 'SALON', 'SALUT', 'SEARA', 'SIGUR', 'SPUNE', 'STARE', 'STIRI', 'STOCK', 'SUPER', 'TABEL', 'TARIF', 'TEMEI',
  'TIGRU', 'TINTA', 'TOTAL', 'TRANS', 'ULTRA', 'URCAT', 'VERDE', 'VIDEO', 'VIATA', 'VREME', 'ZILEI', 'ZILNIC'
];

// Search local Romanian dictionary
const searchRomanianDictionary = (letters, limit = 10) => {
  if (!letters || letters.length < 2) return [];

  const inputDigits = lettersToDigits(letters);
  const inputUpper = letters.toUpperCase();

  const results = [];

  for (const word of romanianWords) {
    if (word.length > 5) continue; // Max 5 letters

    const wordDigits = lettersToDigits(word);

    // Match if word starts with input letters OR if digits match
    if (word.startsWith(inputUpper) || wordDigits.startsWith(inputDigits)) {
      results.push({
        word: word,
        digits: wordDigits,
        language: 'ro'
      });
    }

    if (results.length >= limit) break;
  }

  return results;
};

// Search Datamuse API for English words
const searchEnglishDictionary = async (letters, limit = 15) => {
  if (!letters || letters.length < 2) return [];

  try {
    // Use Datamuse API with spelling pattern
    // sp=pattern* finds words starting with pattern
    const response = await fetch(
      `https://api.datamuse.com/words?sp=${letters.toLowerCase()}*&max=${limit}&md=f`
    );

    if (!response.ok) {
      console.error('Datamuse API error:', response.status);
      return [];
    }

    const data = await response.json();

    // Filter to words with 3-5 characters and convert
    return data
      .filter(item => item.word.length >= 3 && item.word.length <= 5)
      .filter(item => /^[a-zA-Z]+$/.test(item.word)) // Only alphabetic
      .slice(0, limit)
      .map(item => ({
        word: item.word.toUpperCase(),
        digits: lettersToDigits(item.word),
        language: 'en',
        frequency: item.tags ? parseInt(item.tags[0]?.replace('f:', '') || '0') : 0
      }));
  } catch (error) {
    console.error('Error fetching from Datamuse:', error);
    return [];
  }
};

// Combined search - both Romanian (local) and English (online)
export const searchVanityWords = async (letters, limit = 20) => {
  if (!letters || letters.length < 2) return [];

  // Search both in parallel
  const [romanianResults, englishResults] = await Promise.all([
    Promise.resolve(searchRomanianDictionary(letters, Math.ceil(limit / 2))),
    searchEnglishDictionary(letters, Math.ceil(limit / 2))
  ]);

  // Combine and deduplicate by word
  const seen = new Set();
  const combined = [];

  // Add Romanian first (priority for local results)
  for (const item of romanianResults) {
    if (!seen.has(item.word)) {
      seen.add(item.word);
      combined.push(item);
    }
  }

  // Add English results
  for (const item of englishResults) {
    if (!seen.has(item.word)) {
      seen.add(item.word);
      combined.push(item);
    }
  }

  return combined.slice(0, limit);
};

// Search for words that match a specific digit pattern
export const searchByDigits = async (digits, limit = 20) => {
  if (!digits || digits.length < 2) return [];

  // This is more complex - we need to find words that convert to these digits
  // For local Romanian, we can filter directly
  const romanianMatches = romanianWords
    .filter(word => word.length >= 3 && word.length <= 5)
    .filter(word => lettersToDigits(word).startsWith(digits))
    .slice(0, Math.ceil(limit / 2))
    .map(word => ({
      word: word,
      digits: lettersToDigits(word),
      language: 'ro'
    }));

  // For English, we'd need a reverse lookup which Datamuse doesn't directly support
  // So we'll just return Romanian matches for digit-based search
  return romanianMatches;
};

export default {
  lettersToDigits,
  searchVanityWords,
  searchByDigits
};
